import React, { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";

import { View } from "../storage/routes";

import "./VOD.scss";
import { Skeleton } from "@mui/material";

import { AnimatePresence, motion } from "framer-motion";
import { sportradarApi, videocietyApi } from "../services/apis";
import "../Components/Modals/DemoModal.module.scss";
import { SRSlide, VCHeroSlide } from "../Components/Slides";
import MenuBar from "../Components/Bars/MenuBar";
import { displayModal, forceUI } from "../storage/emitter";
import appProperties from "../storage/app-properties";

import OnDemandLogo from "assets/images/ondemand.svg";

SwiperCore.use([Autoplay, Pagination]);

const SRModules = ({ modules }) => {
  if (modules?.length <= 0) return null;
  return modules.map((module) => {
    const sliderTitle = module.title?.en || module.title;
    return (
      <div className="slider">
        <div className="slider-title">{sliderTitle}</div>
        <Swiper
          key={module.id}
          slidesPerView={"auto"}
          spaceBetween={22}
          centeredSlides={false}
          loop={false}
          pagination={false}
          navigation={false}
          className="slider-content"
        >
          {module.content?.map((asset) => {
            return (
              <SwiperSlide key={asset.id} className={"slider-slide"}>
                <SRSlide asset={asset} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  });
};

export const heroSkellyAnim = {
  hidden: {
    opacity: 0,
    position: "absolute",
  },
  visible: {
    opacity: 1,
    position: "relative",
  },
  exit: {
    opacity: 0,
    position: "absolute",
  },
};

const VOD = () => {
  const [vc, setVC] = useState([]);
  const [srModules, setSRModules] = useState([]);

  const buttons = useMemo(() => {
    return [
      {
        id: "featured",
        text: "Featured",
        onClick: () => {},
        isActive: true,
      },
      {
        id: "movies",
        text: "Movies",
        onClick: () => {
          displayModal("demo");
        },
        isActive: false,
      },
      {
        id: "tv-shows",
        text: "TV Shows",
        onClick: () => {
          displayModal("demo");
        },
        isActive: false,
      },
      {
        id: "my-list",
        text: "My List",
        onClick: () => {
          displayModal("demo");
        },
        isActive: false,
      },
    ];
  }, []);

  useEffect(() => {
    videocietyApi
      .getItems(
        "mo32795201,mo37534975,mo38196028,mo37776982,mo39615319,mo38168487,mo38935563,mo39366315,mo9648466,mo3921716"
      )
      .then((items) => {
        setVC(items);
      });

    sportradarApi.getPage(13636).then((resp) => {
      setSRModules(resp?.data?.data?.modules);
    });
  }, []);

  return (
    <View>
      <div id="vod">
        {appProperties.ltd && (
          <div className="brand--logo">
            <img src={OnDemandLogo} alt="Foxxum - On Demand Logo" />
          </div>
        )}
        <MenuBar buttons={buttons} />
        {vc.length > 0 && (
          <Swiper
            slidesPerView={1}
            spaceBetween={0}
            centeredSlides={true}
            autoplay={{
              delay: 6e3,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            className="hero"
            noSwipingSelector=".button"
          >
            {vc.map((item) => {
              return (
                <SwiperSlide key={item.id}>
                  <VCHeroSlide asset={item} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        <AnimatePresence>
          {vc?.length <= 0 && (
            <motion.div
              variants={heroSkellyAnim}
              initial="visible"
              animate="visible"
              exit="exit"
              className="hero hero--skelly"
            >
              <Skeleton
                className="hero hero--skelly"
                animation="wave"
                variant="rectangular"
              />
              <div className="hero--overlay" />
            </motion.div>
          )}
        </AnimatePresence>
        <SRModules modules={srModules} />
      </div>
    </View>
  );
};

export default VOD;
